// extracted by mini-css-extract-plugin
export default {"container":"Service__container___24yxE","content":"Service__content___6SfJI","services":"Service__services___2ZFpd"};